import { useEffect, useState } from "react";
import { Check, X } from "lucide-react";
import { WingedM } from "./Logo";
import { scrollToSection } from "@/lib/lenis";

function Shell({ children }) {
  return (
    <div className="relative min-h-screen bg-ink text-white flex items-center justify-center p-6 overflow-hidden">
      <div className="grain" aria-hidden="true" />
      <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[460px] rounded-full bg-gold/10 blur-[130px]" />
      <div className="relative text-center max-w-md w-full border border-white/10 bg-panel p-10 z-10">{children}</div>
    </div>
  );
}

export function PaymentSuccess() {
  const [status, setStatus] = useState("pending");
  const sessionId = new URLSearchParams(window.location.search).get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let cancelled = false;
    const poll = async (tries) => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/payments/status/${sessionId}`);
        const data = await res.json();
        if (data.payment_status === "paid") {
          if (!cancelled) setStatus("paid");
          return;
        }
      } catch (e) {}
      if (tries > 0 && !cancelled) setTimeout(() => poll(tries - 1), 2000);
    };
    poll(15);
    return () => {
      cancelled = true;
    };
  }, [sessionId]);

  return (
    <Shell>
      <div className="flex justify-center">
        <WingedM size={72} />
      </div>
      {status === "paid" ? (
        <div data-testid="payment-success-paid">
          <span className="mx-auto mt-8 w-14 h-14 flex items-center justify-center bg-gold text-ink rounded-full">
            <Check size={26} />
          </span>
          <h1 className="mt-6 font-display font-black uppercase tracking-tight text-3xl">Zahlung bestätigt</h1>
          <p className="mt-3 text-slate-300 text-sm leading-relaxed">
            Willkommen im Ring! Deine „Danke für deine Bestellung"-E-Mail ist unterwegs an deine E-Mail-Adresse.
          </p>
        </div>
      ) : (
        <div data-testid="payment-success-pending">
          <h1 className="mt-8 font-display font-black uppercase tracking-tight text-3xl">Zahlung wird verarbeitet…</h1>
          <p className="mt-3 text-slate-300 text-sm leading-relaxed">
            Wir bestätigen deine Zahlung sobald Stripe sie abgeschlossen hat. Diese Seite aktualisiert sich automatisch.
          </p>
        </div>
      )}
      <button
        data-testid="payment-back-home"
        onClick={() => {
          window.location.href = "/";
        }}
        className="btn-gold mt-8 w-full justify-center"
      >
        Zurück zur Seite
      </button>
    </Shell>
  );
}

export function PaymentCancel() {
  return (
    <Shell>
      <div className="flex justify-center">
        <WingedM size={72} />
      </div>
      <span className="mx-auto mt-8 w-14 h-14 flex items-center justify-center border border-white/20 text-white/70 rounded-full">
        <X size={24} />
      </span>
      <h1 data-testid="payment-cancel-title" className="mt-6 font-display font-black uppercase tracking-tight text-3xl">
        Zahlung abgebrochen
      </h1>
      <p className="mt-3 text-slate-300 text-sm leading-relaxed">
        Kein Problem — es wurde nichts abgebucht. Der Drop kommt bald: Melde dich beim VIP Ring Club an, um nichts zu verpassen.
      </p>
      <button
        data-testid="payment-cancel-home"
        onClick={() => {
          window.location.href = "/";
        }}
        className="btn-gold mt-8 w-full justify-center"
      >
        Zurück zur Seite
      </button>
    </Shell>
  );
}
